import {
    Box,
    Button,
    Paper,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
  } from "@mui/material";
  import React, { useState } from "react";
  import Grid from '@mui/material/Grid2';
  import cashregister from '../../assets/serve/cash-register.png';
  import cloud from '../../assets/serve/cloud.png';
  import gamecontroller from '../../assets/serve/gamecontroller.png';
  import graduation from '../../assets/serve/graduation.png';
  import pc from '../../assets/serve/pc.png';
  import puzzle from '../../assets/serve/puzzle.png';
  import sailbot from '../../assets/serve/sailboat.png';
  import storefront from '../../assets/serve/storefront.png';
  import swap from '../../assets/serve/swap.png';
  import ticket from '../../assets/serve/ticket.png';
  import vector from '../../assets/serve/vector.png';
  import club from '../../assets/serve/club.png';

  const industryData = [
    {
      title: "MARKETPLACE",
      description: "PAYMENTS FOR ONLINE MARKETPLACES\n& MULTI-VENDOR PLATFORMS",
      icon: storefront,
      variant: "purple",
    },
    {
      title: "RETAIL",
      description: "SECURE CHECKOUT\nFOR E-COMMERCE SALES",
      icon: cashregister,
      variant: "beige",
    },
    {
      title: "ONLINE EDUCATION",
      description:
        "SMOOTH TRANSACTIONS\nFOR E-LEARNING PLATFORMS & DIGITAL COURSES",
      icon: graduation,
      variant: "purple",
    },
    {
      title: "DIGITAL PLATFORMS",
      description: "SUBSCRIPTION & DIGITAL\nCONTENT PAYMENT SOLUTIONS",
      icon: pc,
      variant: "beige",
    },
    {
      title: "IT-SAAS",
      description: "SCALABLE BILLING FOR\nSOFTWARE-AS-A-SERVICE BUSINESSES",
      icon: cloud,
      variant: "beige",
    },
    {
      title: "MOBILITY",
      description: "PAYMENTS FOR RIDE-SHARING\n& RENTALS SERVICES",
      icon: vector,
      variant: "purple",
    },
    {
      title: "E-TICKETING",
      description: "FAST CHECKOUT FOR\nEVENTS & TRANSPORTATION",
      icon: ticket,
      variant: "purple",
    },
    {
      title: "TRAVEL",
      description: "PAYMENT PROCESSING FOR\nAIRLINES, HOTELS & AGENCIES",
      icon: sailbot,
      variant: "purple",
    },
    {
      title: "GAMING",
      description: "IN-GAME TRANSACTIONS\n& PAYOUTS",
      icon: puzzle,
      variant: "beige",
    },
    {
      title: "E-SPORT",
      description: "PAYMENTS\nFOR TOURNAMENTS & TEAMS",
      icon: gamecontroller,
      variant: "beige",
    },
    {
      title: "GAMBLING",
      description: "COMPLIANT TRANSACTIONS\nFOR CASINOS & ONLINE BETTING",
      icon: club,
      variant: "beige",
    },
    {
      title: "FOREX",
      description: "FAST DEPOSITS & WITHDRAWALS\nFOR TRADING PLATFORMS",
      icon: swap,
      variant: "purple",
    },
  ];
  
  const Serve = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAllItems, setShowAllItems] = useState(false);
    
    const handleShowAll = () => {
      setShowAllItems(true);
    };
    
    // Determine which items to display
    const displayedItems = isMobile && !showAllItems 
      ? industryData.slice(0, 3) 
      : industryData;

    return (
      <Stack 
        alignItems={{sm: "center", xs: "flex-start"}} 
        display="flex"
        flexDirection="column"
        padding={{sm: "0 20px", xs: "0px 10px"}}
        margin="0 auto"
        gap="32px"
        alignSelf="stretch"
        maxWidth="1320px"
        width="100%"
      >
        <Typography
        variant="subtitle8"
          textTransform="uppercase"
          fontStyle="normal"
          alignSelf="stretch"
        >
          <Box component="span" sx={{ color: "darkPurple.500" }}>
            Industries we{" "}
          </Box>
          <Box component="span" sx={{ color: "lightPurple.500" }}>
            serve
          </Box>
        </Typography>
  
        <Box 
            width= "100%"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="flex-end"
            gap= {{sm: "6px", xs: "4px"}}
        >
          <Grid container spacing={1.5}>
            {displayedItems.map((industry, index) => (
              <Grid size={{xs: 12, sm: 4}} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    height: 247,
                    p: 5,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    bgcolor:
                      industry.variant === "purple" ? "#F4F1FA" : "#F9F7F0",
                    borderRadius: 3,
                    gap: "48px"
                  }}
                >
                  <Stack 
                  spacing={1}
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  alignSelf="stretch"
                  >
                    <Box
                      sx={{
                        p: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        bgcolor:
                          industry.variant === "purple" ? "lightPurple.400" : "lime.100",
                        borderRadius: 3,
                        width: "fit-content",
                      }}
                    >
                      <Box
                        component="img"
                        src={industry.icon}
                        sx={{
                          width: 32,
                          height: 32,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 0
                        }}
                      />
                    </Box>
  
                    <Typography
                      color= "#321338"
                      alignSelf="stretch"
                      fontSize={{sm: "22px", xs: "20px"}}
                      fontStyle="normal"
                      fontFamily="Manrope"
                      lineHeight={1.2}
                      textTransform="uppercase"
                      fontWeight={500}
                    >
                      {industry.title}
                    </Typography>
                  </Stack>
  
                  <Typography
                    alignSelf="stretch"
                    fontSize="16px"
                    fontStyle="normal"
                    fontFamily="Manrope"
                    lineHeight={1.2}
                    textTransform="uppercase"
                    fontWeight={500}
                    sx={{
                      color:
                        industry.variant === "purple" ? "#6B5A8E" : "#8A7E55",
                    }}
                  >
                    {industry.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
          {isMobile && !showAllItems && (
            <Box sx={{ display: 'flex', width: '100%', mt: 3 }}>
              <Button
                variant="contained"
                onClick={handleShowAll}
                sx={{
                  bgcolor: "#CDBCF3",
                  color: "#321338",
                  fontWeight: 500,
                  borderRadius: "14px",
                  fontSize: "16px",
                  height: "48px",
                  display: "flex",
                  textTransform: "uppercase",
                  padding: "0px 40px",
                  "&:hover": {
                    bgcolor: "#D9EF0A",
                  },
                }}
              >
                Show All
              </Button>
            </Box>
          )}
        </Box>
      </Stack>
    );
  };
  
  export default Serve;
  